export const PRICING_CLEAR_DATA = 'PRICING_CLEAR_DATA';
export const PRICING_SELECT_LANGUAGE = 'PRICING_SELECT_LANGUAGE';

export const PRICING_DATA_FETCH = 'PRICING_DATA_FETCH';
export const PRICING_DATA_SUCCESS = 'PRICING_DATA_SUCCESS';
export const PRICING_DATA_FAILURE = 'PRICING_DATA_FAILURE';

export const UPDATE_PRICING_DATA_FETCH = 'UPDATE_PRICING_DATA_FETCH';
export const UPDATE_PRICING_DATA_SUCCESS = 'UPDATE_PRICING_DATA_SUCCESS';
export const UPDATE_PRICING_DATA_FAILURE = 'UPDATE_PRICING_DATA_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Pricing/actionTypes.js